import { FC } from "react";
import InnerPage from "../../../../shared/components/InnerPage";
import Icon from "../../../../shared/components/Icon";
import { EXTERNAL, PATHS } from "../../../../paths";

const SecuritasGroupPage: FC = () => (
  <InnerPage
    eyebrow="Kurumsal"
    title="Securitas Grup"
    crumbs={[{ label: "Hakkımızda", to: PATHS.about }, { label: "Securitas Grup" }]}
    seoDescription="Securitas Grup, 90 yıllık tecrübesiyle müşterilerine yenilikçi, kaliteli ve sürdürülebilir güvenlik çözümleri sunar."
  >
    <div className="it-prose">
      <h2>Securitas Grup</h2>
      <p>
        İnsanları güvende tuttuğumuz 90 yıllık tecrübemiz ile potansiyeli ve
        ilerlemeyi görebiliyoruz. Her daim dünyanızın daha güvenli hale gelmesine
        yardımcı oluyoruz.
      </p>
      <p>
        Müşterilerimize yenilikçi, kaliteli ve sürdürülebilir çözümler sunarak
        risklerin önüne geçmelerine yardımcı oluyoruz.
      </p>
      <p style={{ marginTop: 28 }}>
        <a
          className="it-btn"
          href={EXTERNAL.securitasGroup}
          target="_blank"
          rel="noopener noreferrer"
        >
          Daha fazla bilgi <Icon name="ext" />
        </a>
      </p>
    </div>
    <div className="it-photo it-photo--land">
      <img
        src="/uploads/site/securitas-grup.jpg"
        alt="Securitas devriye aracı, gece şehir manzarası"
      />
    </div>
  </InnerPage>
);

export default SecuritasGroupPage;
